<template>
    <div class="gray-background">
        <div class="form-title">
            <span>{{ formTitle }}</span>
        </div>
        <div class="form">
            <b-form-group :label="labelName">
                <b-form-input v-if="inputType !== 'textarea'" id="form-tooltip" v-model="textToCopy" :readonly="readonly" @click="copyText(textToCopy)"></b-form-input>
                <b-form-textarea v-else id="form-tooltip" v-model="textToCopy" :readonly="readonly" @click="copyText(textToCopy)"></b-form-textarea>
                <b-tooltip target="form-tooltip" triggers="hover" placement="bottom">
                    Click pentru a copia textul
                </b-tooltip>
            </b-form-group>
        </div>
    </div>
</template>

<script>
import { BFormInput, BFormGroup, BFormTextarea, BTooltip } from "bootstrap-vue";
export default {
    components: {
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BTooltip
    },
    props: {
        labelName: {
            type:String,
            default:""
        },
        inputType: {
            type:String,
            default:""
        },
        textToCopy: {
            type:String,
            default:""
        },
        formTitle: {
            type:String,
            default:""
        },
        readonly: {
            type:Boolean,
            default: true
        },
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    created() {
    },
    methods: {
        copyText(text){
            navigator.clipboard.writeText(text)
            this.$toast.success('Textul a fost copiat cu succes.');
        }
    }
}
</script>

<style scoped>
.gray-background{
    background: #fbfbfb;
}
.form{
    padding: 15px;
}
.form-group >>> legend{
    font-size: 14px;
    font-weight: 600;
}
input, textarea{
    font-size: 12px;
    border-radius: 0;
    background-color: transparent !important;
    cursor: pointer;
}
.form-title{
    color: #fff;
    background-color: #5db2ff;
    font-weight: 600;
    font-size: 17px;
    padding: 10px;
    display: flex;
    align-items: center;
    min-height: 50px;
}
.form-group .b-tooltip >>> .tooltip-inner{
    max-width: 200px;
    padding: 4px 10px;
    text-align: center;
    background: #eef2f9;
    color: #676d86;
    border-radius: 0.25rem;
}
.form-group .b-tooltip >>> .arrow:before{
    border-width: 0 0.3rem 0.3rem;
    border-bottom-color: #eef2f9;
}
</style>